// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36Tgl","newExpiryDate":"styles_newExpiryDate__15Uh1","footer":"styles_footer__3JMQH"};